import React, { useState } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import _ from "underscore";

const EventLogTable = ({
  singleEventDetails,
  setSingleEventDetails,
  setSelectedEventID,
}) => {
  const [hoveredEventID, setHoveredEventID] = useState(null);

  // when listing out an events bandwidth consumption, to display one the same day of data, we need to pass two data points to be able to make a line on the chart.
  // so if there is two data points and they are the same then only display one log entry on the table. No need to display two identical entries.
  let eventLog = singleEventDetails;

  if (
    singleEventDetails.length > 1 &&
    _.isMatch(singleEventDetails[0], singleEventDetails[1])
  ) {
    eventLog = [singleEventDetails[0]];
  }

  return (
    <Box sx={{ width: "100%" }}>
      <TableContainer component={Paper} sx={{ maxHeight: "235px" }}>
        <Table
          aria-label="events bandwidth table"
          size="small"
          stickyHeader={true}
        >
          <TableHead>
            <TableRow>
              <TableCell>Log Date</TableCell>
              <TableCell align="right">Live (GB)</TableCell>
              <TableCell align="right">VOD (GB)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {eventLog.length > 0 &&
              eventLog.map((event, i) => (
                <TableRow
                  key={i}
                  hover
                  data-eventid={event.eventID}
                  sx={{
                    ...(event.eventID === hoveredEventID && {
                      backgroundColor: "#eeeeee",
                    }),
                  }}
                >
                  <TableCell component="th" scope="row">
                    {event.logDay}
                  </TableCell>
                  <TableCell align="right">
                    {event["Live Consumption"]}
                  </TableCell>
                  <TableCell align="right">
                    {event["Vod Consumption"]}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button
        variant="outlined"
        startIcon={<ArrowBackIosNewIcon />}
        sx={{ float: "right", my: 2 }}
        onClick={() => {
          setSingleEventDetails([]);
          setSelectedEventID(null);
        }}
      >
        Back To All Events
      </Button>
    </Box>
  );
};

export default EventLogTable;
